import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './MainFeatures.scss';
import PictureSlider from '../../widgets/PictureSlider/PictureSlider';

import store from '../../redux/store';
import { connect } from 'react-redux';
import config from '../../config';
import { useHistory, NavLink } from 'react-router-dom';
import { getUrlSeoTitle, getFeaturesTitle } from '../../utils/UtilsClass';
import dayjs from 'dayjs';

const MainFeatures = (props) => {
  const { curLang, homeData, data } = props;

  const headerTitle = {
    sc: '专题',
    en: 'FEATURES',
    tc: '專題',
  };

  return (
    <section className="main-features">
      <Row>
        <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="slider-col">
          <PictureSlider items={homeData[curLang]?.news || []} />
        </Col>
        <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="img-col">
          {data?.slice(0, 2).map((item, index) => (
            <div
              className="main-features-card"
              key={`${item.topMetadata.featureId}${item.basicInfo.templateType}`}
            >
              <NavLink
                to={(location) => ({
                  ...location,
                  pathname: `${config.routePathTo}/${curLang}/highlight/${
                    item.topMetadata.featureId
                  }/${getUrlSeoTitle(getFeaturesTitle(item, 'en'))}-${dayjs(
                    item.basicInfo.date,
                  ).format('YYYY-MM-DD')}`,
                  search: `?p1=${item.basicInfo.templateType}&ref_source=fashionally_home_feature`,
                })}
              >
                <img src={item.basicInfo.thumbnail} />
                <div className="img-detail">
                  <div className="pretitle">{headerTitle[curLang]}</div>
                  <div className="description">{getFeaturesTitle(item, curLang)}</div>
                </div>
              </NavLink>
            </div>
          ))}
        </Col>
      </Row>
    </section>
  );
};

export default MainFeatures;
